<template>
  <div class="tab-bar">
    <button
      v-for="tab in tabs"
      :key="tab.id"
      class="tab-bar__item"
      :class="{ 'tab-bar__item--active': tab.id === current }"
      @click="$emit('change', tab.id)"
      :data-testid="'tab-' + tab.id"
      :aria-label="tab.label"
      :aria-current="tab.id === current ? 'page' : undefined"
      type="button"
    >
      <component :is="tab.icon" class="tab-bar__icon" />
      <span class="tab-bar__label">{{ tab.label }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
import type { Component } from 'vue';

export type TabId = 'home' | 'payments' | 'history' | 'analytics' | 'settings' | 'card' | 'family';

defineProps<{
  tabs: Array<{ id: TabId; label: string; icon: Component }>;
  current: TabId;
}>();

defineEmits<{ change: [id: TabId] }>();
</script>

<style scoped lang="scss">
.tab-bar {
  display: flex;
  justify-content: space-around;
  align-items: stretch;
  height: 62px;
  padding: 6px 4px 8px;
}

.tab-bar__item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3px;
  flex: 1 1 0;
  min-width: 0;
  color: var(--text-3);
  transition: color var(--dur-fast) var(--ease-out);

  &:active { transform: scale(0.96); }
}

.tab-bar__item--active {
  color: var(--gold);
}

.tab-bar__icon {
  width: 22px;
  height: 22px;
  stroke: currentColor;
  fill: none;
}

.tab-bar__label {
  font-size: 10px;
  font-weight: 500;
  letter-spacing: 0.02em;
  white-space: nowrap;
}
</style>
